export default (() => {
    // Union of Chrome, Firefox, IE, Opera, and Safari console methods
    var methods = [
        'assert',
        'cd',
        'clear',
        'count',
        'countReset',
        'debug',
        'dir',
        'dirxml',
        'error',
        'exception',
        'group',
        'groupCollapsed',
        'groupEnd',
        'info',
        'log',
        'markTimeline',
        'profile',
        'profileEnd',
        'select',
        'table',
        'time',
        'timeEnd',
        'timeStamp',
        'timeline',
        'timelineEnd',
        'trace',
        'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});
    var method;
    var noop = function() {};
    while (length--) {
        method = methods[length];
        // define undefined methods as noops to prevent errors
        if (!console[method]) console[method] = noop;
    }
})();



// WEBPACK FOOTER //
// ./polyfills/browserNoConsoleFix.js